function nextElement(element: HTMLElement, selector?: string): HTMLElement | undefined {
    let sibling = element.nextElementSibling as HTMLElement | null;

    if (selector == null) {
        return sibling ?? undefined;
    }

    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling as HTMLElement | null;
    }

    return undefined;
}

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        nextElement(selector?: string): HTMLElement | undefined;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.nextElement = function (selector?: string): HTMLElement | undefined {
    return nextElement(this, selector);
};

// ----------------------------------------------------------------------------

export default nextElement;
